import { Button } from '@/components/Button/Button';
import { EmptyState } from '@/components/EmptyState/EmptyState';
import { Spinner } from '@/components/Spinner/Spinner';

import styles from './AccessNotice.module.css';

export interface AccessNoticeProps {
  /** What the screen is called, e.g. `lenders`. */
  area: string;
  state: 'checking' | 'none' | 'unavailable';
  onRetry?: () => void;
}

/** Stands in for a screen while access is checked, or once it is refused. */
export function AccessNotice({ area, state, onRetry }: AccessNoticeProps) {
  if (state === 'checking') {
    return (
      <p className={styles.checking} role="status">
        <Spinner /> Checking your access…
      </p>
    );
  }
  if (state === 'unavailable') {
    return (
      <EmptyState
        action={
          onRetry ? (
            <Button onClick={onRetry} variant="ghost">
              Try again
            </Button>
          ) : null
        }
        icon="lock-key"
        title="We couldn't check your access"
        tone="warn"
      >
        <p>Something went wrong asking who can see {area}. This is usually brief.</p>
      </EmptyState>
    );
  }
  return (
    <EmptyState icon="lock-key" title={`You don't have access to ${area}`} tone="warn">
      <p>Ask an admin to give you a role that includes {area}, then sign in again.</p>
    </EmptyState>
  );
}
